import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Gallery from './components/gallery/Gallery';
import Navbar from './components/navbar/Navbar';
import ContactPage from './components/contact/ContactPage';
import Footer from './components/footer/Footer';
import Team from './components/team/Team';
import AboutUs from './components/about/AboutUs';
import HomePage from './components/home/HomePage';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="about" element={<AboutUs />} />
          <Route path="team" element={<Team />} />
          <Route path="gallery" element={<Gallery />} />
          <Route path="contact" element={<ContactPage />} />
        </Routes>
      </main>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
